import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
// Constants
import constants, { BNPL_DOMAINS_REGEX } from "./constants/session.utils.constants";
var generateTimestamp = function generateTimestamp(expiresIn) {
  var currentDate = new Date(),
    secondsToAdd = (+expiresIn - constants.WARNING_TIME_MS) / 1000;
  currentDate.setSeconds(currentDate.getSeconds() + secondsToAdd);
  return currentDate;
};
var isBNPLDomain = function isBNPLDomain() {
  var _window$location;
  return BNPL_DOMAINS_REGEX.test(((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || '');
};
var isAmazonDomain = function isAmazonDomain() {
  var _window$location2, _window$location2$hos;
  return (_window$location2 = window.location) === null || _window$location2 === void 0 ? void 0 : (_window$location2$hos = _window$location2.hostname) === null || _window$location2$hos === void 0 ? void 0 : _window$location2$hos.includes('amazon');
};
var isGilDomain = function isGilDomain() {
  var _window$location3, _window$location3$hos;
  return (_window$location3 = window.location) === null || _window$location3 === void 0 ? void 0 : (_window$location3$hos = _window$location3.hostname) === null || _window$location3$hos === void 0 ? void 0 : _window$location3$hos.includes('gil');
};
var isLocalhostDomain = function isLocalhostDomain() {
  var _window$location4, _window$location4$hos;
  return (_window$location4 = window.location) === null || _window$location4 === void 0 ? void 0 : (_window$location4$hos = _window$location4.hostname) === null || _window$location4$hos === void 0 ? void 0 : _window$location4$hos.includes('localhost');
};
var getCookieDomain = function getCookieDomain() {
  switch (true) {
    case isLocalhostDomain():
      return window.location.hostname;
    case isAmazonDomain():
      return constants.AMAZON_DOMAIN;
    case isGilDomain():
    case isBNPLDomain():
      return constants.BNPL_DOMAIN;
    default:
      return '';
  }
};
var isDomainACustomerDomain = function isDomainACustomerDomain(domain) {
  return constants.AUTH_GUARD_PROVIDER_PATHS.CUSTOMER.some(function (path) {
    return domain === null || domain === void 0 ? void 0 : domain.includes(path);
  });
};
var checkCurrentDomain = function checkCurrentDomain(domain) {
  return window.location.hostname === domain;
};
var isCurrentDomain = function isCurrentDomain(domain) {
  return isDomainACustomerDomain(domain) || checkCurrentDomain(domain);
};
export { generateTimestamp, getCookieDomain, isCurrentDomain, isBNPLDomain, isAmazonDomain, isLocalhostDomain };